import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alignment, Button, Classes, Dialog, Divider, FormGroup, Tag, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, sortBy } from "../../utils";
import LoadingModal from "../loading/LoadingModal";
import { DetStore } from "../../stores/det/DetStore";


@observer
export default class MensagensDetPage extends React.Component<{}, {}> {

  obs = observable({
    current_page: 1 as number,
    selectEmpresa: newEmpresa() as IEmpresa,
    open_visualiza_mensagem: false as boolean,
    mensagem: [] as any
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    this.obs.current_page = 1
  }

  handleBuscaTarefasPaged = async (page: number) => {

    this.obs.current_page = page
    DetStore.obs.loading_mensagens = true

    await DetStore.handleMensagensPaged(page, this.obs.selectEmpresa.cnpj);

  };

  handleBuscaTarefas = async (empresa) => {

    this.obs.selectEmpresa = empresa
    DetStore.obs.loading_mensagens = true

    await DetStore.handleMensagensPaged(this.obs.current_page = 1, this.obs.selectEmpresa.cnpj);

  };

  handleAtualizaTarefasPaged = async () => {

    if (this.obs.selectEmpresa.cnpj == "") {
      toast.warning('Selecione uma empresa!', {});
      return;
    }

    DetStore.obs.loading_mensagens = true

    await DetStore.handleMensagensPaged(this.obs.current_page, this.obs.selectEmpresa.cnpj);

  };

  async handleVerMensagem(mensagem: any) {

    this.obs.mensagem = mensagem

    this.obs.open_visualiza_mensagem = true

  }

  nl2br(str) {

    if (!str) return ""

    return str.replace(/(\r\n|\n|\r|\\n)/g, '<br />');
  }

  dateFormatter(cell, row) {

    if (!cell) return

    return moment(cell).format("DD/MM/YYYY") + " ás " + moment(cell).format("HH:mm");

  };

  async handleVisualizarMensagem(mensagem: any) {

    this.obs.mensagem = mensagem

    this.obs.open_visualiza_mensagem = true

    let res = await DetStore.handleSaveLog(mensagem)

    if (res) {

      await DetStore.handleMensagensPaged(this.obs.current_page, this.obs.selectEmpresa.cnpj);

      await DetStore.handleConsultaMensagens()

    }

  }

  stringToColor = (str: string) => {

    let hash = 0;

    for (let i = 0; i < str.length; i++) {

      hash = str.charCodeAt(i) + ((hash << 6) - hash);

    }

    const hue = Math.abs(hash) % 300;

    return `hsl(${hue}, 55%, 55%)`;

  }

  origemFormatter = (cell, row) => {

    const bg = this.stringToColor(row.sistema_origem ?? "desconhecido");

    return (
      <span style={{
        backgroundColor: bg,
        color: "white",
        fontSize: "10px",
        padding: "2px 6px",
        borderRadius: "3px",
      }}>
        {row.sistema_origem}
      </span>
    );

  }

  render() {

    const formatVisualizaMensagem = (cell, row) => {
      return (
        <>
          {row.visualizada ?

            <img src="/images/envelope.png" width={20} style={{ cursor: "pointer" }} onClick={(e) => this.handleVerMensagem(row)} />

            :

            <img src="/images/e-mail.png" width={20} style={{ cursor: "pointer" }} onClick={(e) => this.handleVisualizarMensagem(row)} />

          }
        </>
      )
    }

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";


    return (
      <>
        <MDBRow>
          <MDBCol md="4">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas.filter(x => x["filial"] == false)}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.handleBuscaTarefas(e)}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT} />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handleAtualizaTarefasPaged()}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>
        <div>
          <BootstrapTable className="TableDefault" ref="table" data={DetStore.obs.mensagens_det}>
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="titulo" width="40%">Titulo</TableHeaderColumn>
            <TableHeaderColumn dataField="remetente" width="30%">Remetente</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.origemFormatter} dataField="sistema_origem" width="15%">Sistema Origem</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.dateFormatter} dataField="data_criacao" width="15%">Data Criação</TableHeaderColumn>
            <TableHeaderColumn dataFormat={formatVisualizaMensagem} width="5%">LER</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={DetStore.obs.mensagens_length}
            pageSize={15}
            onPageChange={page => this.handleBuscaTarefasPaged(page)} />
        </div>

        <Dialog
          isOpen={this.obs.open_visualiza_mensagem}
          onClose={(e) => this.obs.open_visualiza_mensagem = false}
          className="modal-msg"
        >
          <div className={Classes.DIALOG_BODY} >

            <b>Remetente: </b>{this.obs.mensagem.remetente}
            <br />
            <b>Assunto: </b>{this.obs.mensagem.titulo}
            <br />
            <b>Data: </b>{this.dateFormatter(this.obs.mensagem.data_criacao, "")}

            <br />
            <br />
            <Divider style={{ margin: 0 }} />
            <br />

            <div style={{ maxHeight: 500, overflow: "auto", paddingRight: 10 }}>
              <div dangerouslySetInnerHTML={{ __html: this.nl2br(this.obs.mensagem.texto) }} style={{ textAlign: "justify" }} />
            </div>

          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.obs.open_visualiza_mensagem = false} />
          </div>
        </Dialog>

        <LoadingModal open={DetStore.obs.loading_mensagens} onClose={() => DetStore.obs.loading_mensagens = false} title={"Buscando mensagens"} />

      </>
    )
  }
}

